var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',_vm._g(_vm._b({},'base-button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('base-loader',{attrs:{"loading":true}}):_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }